/** Client-side hint only: the server enforces the real rules (length, common passwords, email name). */
export interface Strength { score: 0 | 1 | 2 | 3 | 4; label: "weak" | "fair" | "good" | "strong"; ok: boolean }

const COMMON = ["password", "motdepasse", "azerty", "qwerty", "123456", "000000", "modila", "bonjour", "welcome", "iloveyou", "football"];

export function strength(pw: string, email = ""): Strength {
  if (pw.length < 10) return { score: pw.length === 0 ? 0 : 1, label: "weak", ok: false };
  const low = pw.toLowerCase(), local = email.split("@")[0]!.toLowerCase();
  if (COMMON.some((c) => low.includes(c)) || new Set(low).size < 5 || /^\d+$/.test(pw) || (local.length >= 4 && low.includes(local))) return { score: 1, label: "weak", ok: false };
  const kinds = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(pw)).length;
  const words = pw.trim().split(/\s+/).length;
  let s = 2 + (pw.length >= 14 ? 1 : 0) + (kinds >= 3 || words >= 3 ? 1 : 0);
  s = Math.min(4, s);
  return { score: s as Strength["score"], label: s >= 4 ? "strong" : s === 3 ? "good" : "fair", ok: true };
}
